<template>
  <div class="health-card" :class="statusClass">
    <div class="health-card-header">
      <div class="health-card-icon">
        <i :class="icon" />
      </div>
      <div class="health-card-status">
        <span class="status-badge" :class="`status-${status}`">
          {{ status.toUpperCase() }}
        </span>
      </div>
    </div>
    <div class="health-card-body">
      <h6 class="service-name">
        {{ serviceName }}
      </h6>
      <div class="status-indicator">
        <span class="indicator-dot" :class="`dot-${status}`" />
        <span class="indicator-text">
          {{ statusText }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HealthCard',
  props: {
    serviceName: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      default: 'operational',
      validator: (value) => ['operational', 'warning', 'error'].includes(value),
    },
    icon: {
      type: String,
      default: 'fas fa-circle',
    },
  },
  computed: {
    statusClass() {
      return `health-${this.status}`
    },
    statusText() {
      const texts = {
        operational: 'Operational',
        warning: 'Degraded Service',
        error: 'Service Down',
      }
      return texts[this.status] || 'Unknown'
    },
  },
}
</script>

<style scoped>
.health-card {
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  border-left: 4px solid #ccc;
  transition: all 0.3s ease;
}

.health-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.health-operational {
  border-left-color: #28a745;
}

.health-warning {
  border-left-color: #ffc107;
}

.health-error {
  border-left-color: #dc3545;
}

.health-card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 15px;
}

.health-card-icon {
  font-size: 1.5rem;
  color: #0066cc;
}

.status-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 3px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.status-operational {
  background-color: #d4edda;
  color: #155724;
}

.status-warning {
  background-color: #fff3cd;
  color: #856404;
}

.status-error {
  background-color: #f8d7da;
  color: #721c24;
}

.health-card-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.service-name {
  color: #333;
  font-weight: 600;
  margin: 0;
  font-size: 1rem;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
}

.indicator-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

.dot-operational {
  background-color: #28a745;
}

.dot-warning {
  background-color: #ffc107;
}

.dot-error {
  background-color: #dc3545;
}

.indicator-text {
  color: #666;
}

@keyframes pulse {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
</style>
